import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const MicrosoftTeamsShape = {
  webhook_url: Yup.string().label("Webhook URL").url().required(),
};

export interface MicrosoftTeamsInput {
  webhook_url: string;
}

yupResolver<MicrosoftTeamsInput>(Yup.object().shape(MicrosoftTeamsShape));
